import DropdownMenu from "./DropdownMenu";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import AccountCircle from "@mui/icons-material/AccountCircle";



function HeaderOption({ avatar, Icon, title, dropDown, setDropDown, setShowModal, showModal }: any) {

	const navigate = useNavigate();
	// @ts-ignore
	const userInfo = JSON.parse(localStorage.getItem("user_ats"));
	useEffect(() => {
		if (!userInfo) {
			navigate('/')
		}
	}, [navigate, userInfo])



	return (
		<div className="headerOption" >
			{Icon && <Icon className="headerOption_icon" />}
			{avatar && (
				<>
					<div className="dropdown">
						<button
							onClick={() => setDropDown(true)}
							onMouseEnter={() => setDropDown(true)}
						>
							<AccountCircle className=" headerOption_icon" />
						</button>
					</div>
					{dropDown && (
						<DropdownMenu setDropDown={setDropDown} setShowModal={setShowModal} showModal={showModal} />
					)}
				</>
			)}
			<h4 className="headerOption_title">{title}</h4>
		</div>
	);
}

export default HeaderOption;